import React from 'react';
import LocalizedDate from '../Localization/LocalizedDate';
import RequestStatus from '../Requests/RequestStatus';
import './titleActivityTile.css';
import { Popover } from 'antd';

export default class TitleActivitySummary extends React.Component {
	render() {
		const { request, download, review } = this.props;
		return (
			<React.Fragment>
				{request && (
					<React.Fragment>
						<div>
							<Popover
								trigger="click"
								placement="left"
								content={this.renderPopoverText(
									'You requested',
									request.submittedDate,
								)}>
								<div
									className="icon-hand-paper-o activity-icon"
									style={{
										fontSize: '20px',
										marginTop: '5px',
									}}
								/>
							</Popover>
						</div>
						{request.status === RequestStatus.rejected && (
							<div>
								<Popover
									trigger="click"
									placement="left"
									content={this.renderPopoverText(
										'Declined on',
										request.statusChangedDate,
									)}>
									<div
										className="icon-declined activity-icon"
										style={{
											fontSize: '20px',
											marginTop: '5px',
											color: '#fc601f',
										}}
									/>
								</Popover>
							</div>
						)}
					</React.Fragment>
				)}
				<div>
					{download && (
						<React.Fragment>
							<Popover
								trigger="click"
								placement="left"
								content={this.renderPopoverText(
									'You downloaded',
									download.downloadDate,
								)}>
								<div
									className="icon-cloud-download activity-icon"
									style={{
										fontSize: '20px',
										marginTop: '5px',
									}}
								/>
							</Popover>
						</React.Fragment>
					)}
					<div className="clear" />
				</div>
				<div>
					{review && (
						<React.Fragment>
							<Popover
								trigger="click"
								placement="left"
								content={this.renderPopoverText(
									'You reviewed',
									review.createdDate,
								)}>
								<div
									className="icon-review-icon activity-icon"
									style={{
										fontSize: '20px',
										marginTop: '3px',
									}}
								/>
							</Popover>
						</React.Fragment>
					)}
					<div className="clear" />
				</div>
			</React.Fragment>
		);
	}

	renderPopoverText = (text, dateString) => {
		return (
			<div
				style={{
					fontSize: '11px',
				}}>
				<span>
					{text}
					<br />
				</span>
				<LocalizedDate dateString={dateString} />
			</div>
		);
	};
}
